import React from 'react';

const NotificationsModal = ({ isOpen, onClose, isDarkMode, notifications, onMarkSeen }) => {
    // Mark unseen as seen when modal opens
    React.useEffect(() => {
        if (isOpen) {
            onMarkSeen();
        }
    }, [isOpen, onMarkSeen]);

    if (!isOpen) return null;

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
            <div
                className={`relative w-full max-w-md p-6 mx-4 rounded-2xl shadow-2xl flex flex-col max-h-[80vh] ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
                    }`}
            >
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">Notifications</h2>
                    <button
                        onClick={onClose}
                        className={`p-2 rounded-full transition-colors ${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
                            }`}
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto pr-2 space-y-3">
                    {notifications && notifications.length > 0 ? (
                        notifications.map((notif) => (
                            <div
                                key={notif.id}
                                className={`p-4 rounded-xl border ${isDarkMode
                                    ? notif.is_seen ? 'bg-gray-700/50 border-gray-600' : 'bg-gray-700 border-cyan-500/50'
                                    : notif.is_seen ? 'bg-gray-50 border-gray-200' : 'bg-white border-cyan-300 shadow-sm'
                                    } transition-all`}
                            >
                                <div className="flex justify-between items-start mb-1">
                                    <span className="font-semibold text-sm capitalize">
                                        {notif.action_type ? notif.action_type.replace('_', ' ') : 'Notification'}
                                    </span>
                                    <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                        {formatDate(notif.created_at)}
                                    </span>
                                </div>
                                {notif.meta && notif.meta.reason && (
                                    <p className={`text-sm mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                        {notif.meta.reason}
                                    </p>
                                )}
                                {notif.credits_added > 0 && (
                                    <div className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${isDarkMode ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-700'
                                        }`}>
                                        +{notif.credits_added} Credits added
                                    </div>
                                )}
                                {notif.credits_used > 0 && (
                                    <div className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${isDarkMode ? 'bg-red-500/20 text-red-400' : 'bg-red-100 text-red-700'
                                        }`}>
                                        -{notif.credits_used} Credits used
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className={`text-center py-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            <div className="mb-2">📭</div>
                            <p>No new notifications</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotificationsModal;
